import { z } from 'zod';

export const PartyResponsibleResponseSchema = z.object({
  id: z.uuid(),
  partyId: z.uuid(),
  name: z.string(),
  document: z.string().nullable(),
  rg: z.string().nullable(),
  gender: z.string().nullable(),
  familyRole: z.string().nullable(),
  nickname: z.string().nullable(),
  birthDate: z.iso.date().nullable(),
  occupation: z.string().nullable(),
  jobTitle: z.string().nullable(),
  driversLicenseExpiry: z.iso.date().nullable(),
  photoUrl: z.url().nullable(),
  active: z.boolean(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type PartyResponsibleResponse = z.infer<typeof PartyResponsibleResponseSchema>;

export const CreatePartyResponsibleBodySchema = z.object({
  name: z.string().trim().min(1),
  document: z.string().trim().nullable().optional(),
  rg: z.string().trim().nullable().optional(),
  gender: z.string().trim().nullable().optional(),
  familyRole: z.string().trim().nullable().optional(),
  nickname: z.string().trim().nullable().optional(),
  birthDate: z.iso.date().nullable().optional(),
  occupation: z.string().trim().nullable().optional(),
  jobTitle: z.string().trim().nullable().optional(),
  driversLicenseExpiry: z.iso.date().nullable().optional(),
  photoUrl: z.url().optional(),
});

export type CreatePartyResponsibleBody = z.infer<typeof CreatePartyResponsibleBodySchema>;

export const UpdatePartyResponsibleBodySchema = z.object({
  name: z.string().trim().min(1).optional(),
  document: z.string().trim().nullable().optional(),
  rg: z.string().trim().nullable().optional(),
  gender: z.string().trim().nullable().optional(),
  familyRole: z.string().trim().nullable().optional(),
  nickname: z.string().trim().nullable().optional(),
  birthDate: z.iso.date().nullable().optional(),
  occupation: z.string().trim().nullable().optional(),
  jobTitle: z.string().trim().nullable().optional(),
  driversLicenseExpiry: z.iso.date().nullable().optional(),
  photoUrl: z.url().nullable().optional(),
});

export type UpdatePartyResponsibleBody = z.infer<typeof UpdatePartyResponsibleBodySchema>;

export const CreatePartyResponsibleResponseSchema = z.object({
  responsibleId: z.uuid(),
});

export type CreatePartyResponsibleResponse = z.infer<typeof CreatePartyResponsibleResponseSchema>;

export const UpdatePartyResponsibleResponseSchema = z.object({
  responsibleId: z.uuid(),
  changedFields: z.array(z.string()),
});

export type UpdatePartyResponsibleResponse = z.infer<typeof UpdatePartyResponsibleResponseSchema>;

export const DeletePartyResponsibleResponseSchema = z.object({
  responsibleId: z.uuid(),
});

export type DeletePartyResponsibleResponse = z.infer<typeof DeletePartyResponsibleResponseSchema>;

export const ListPartyResponsiblesResponseSchema = z.object({
  items: z.array(PartyResponsibleResponseSchema),
});

export type ListPartyResponsiblesResponse = z.infer<typeof ListPartyResponsiblesResponseSchema>;

export const GetPartyResponsibleByIdResponseSchema = z.object({
  responsible: PartyResponsibleResponseSchema,
});

export type GetPartyResponsibleByIdResponse = z.infer<typeof GetPartyResponsibleByIdResponseSchema>;

export const PartyResponsibleParamsSchema = z.object({
  partyId: z.uuid(),
  responsibleId: z.uuid(),
});

export type PartyResponsibleParams = z.infer<typeof PartyResponsibleParamsSchema>;
